import { applySwimlaneLayout } from "../core/layout";
/**
 * Shared layered-ELK preset for the process-flow surfaces. Rebuilds swimlane
 * metadata from the assembled nodes' `parentId` decoration, then delegates to
 * `applySwimlaneLayout` for the actual ELK pass.
 */ export const processFlowElkPreset = {
    id: "elkLayered",
    async run (graph) {
        const nodeSwimlaneMap = new Map();
        const swimlaneOrderSet = new Map();
        for (const node of graph.nodes){
            if (node.type === "flowSwimlane") {
                const key = node.id.replace(/^swimlane-/, "");
                const data = node.data;
                swimlaneOrderSet.set(key, {
                    key,
                    label: data.label,
                    laneType: data.laneType
                });
            } else if (node.parentId) {
                nodeSwimlaneMap.set(node.id, node.parentId.replace(/^swimlane-/, ""));
            }
        }
        const result = await applySwimlaneLayout({
            nodes: graph.nodes,
            edges: graph.edges,
            nodeSwimlaneMap,
            swimlaneOrder: Array.from(swimlaneOrderSet.values())
        });
        return {
            nodes: result.nodes,
            edges: result.edges
        };
    }
};

//# sourceMappingURL=elkLayeredPreset.js.map